import React, { useState } from "react";
import logo from "../Assets/logo.svg";
import { FaBars, FaRegWindowClose, FaAngleDown } from "react-icons/fa";

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState("");
  const [isMenuOpenMobil, setIsMenuOpenMobil] = useState("");
  const [isScroll, setIsScroll] = useState(false);

  function toggleMenu(e) {
    const menu = e.target.id;
    if (menu === "mobil") {
      isMenuOpenMobil === "mobil"
        ? setIsMenuOpenMobil("")
        : setIsMenuOpenMobil(menu);
    } else if (menu !== "") {
      isMenuOpen === menu ? setIsMenuOpen("") : setIsMenuOpen(menu);
    } else setIsMenuOpen(menu);
  }
  function closeMenu(e) {
    const menu = e.target.id;
    menu === "mobil" ? setIsMenuOpenMobil("") : setIsMenuOpen("");
  }

  // Changement de couleur d'arrière plan de la barre de menu
  window.onscroll = function () {
    var scrollLimit = 250;
    if (window.scrollY >= scrollLimit) {
      setIsScroll(true);
    } else setIsScroll(false);
  };
  return (
    <>
      <div
        className={`${isScroll ? "navbar isScroll" : "navbar"}`}
        onMouseLeave={closeMenu}
      >
        <a href="/" className="logo">
          <img src={logo} alt="logo" />
        </a>
        <div
          className={`${
            isMenuOpenMobil === "mobil" ? "menu showMobil" : "menu hideMobil"
          }`}
        >
          <div id="mobil" className="ferme buttonClose" onClick={closeMenu}>
            <FaRegWindowClose className="icon" />
          </div>
          <div className="colonneMenu">
            {/******************/}
            {/**** FORFAITS ****/}
            {/******************/}
            <div
              id="forfaits"
              className="premierNiveau"
              onMouseEnter={toggleMenu}
            >
              Nos forfaits <FaAngleDown className="flecheBas" />
            </div>
            <div
              className={`${
                isMenuOpen === "forfaits" ? "sousMenu show" : "sousMenu hide"
              }`}
            >
              <a href="/Pages/Alfa">
                <div className="titreSousMenu">Alfa</div>
                <div className="descriptionSousMenu">
                  Mountains are so simple, they're hard. A fan brush is a
                  fantastic piece of equipment. Use it. Make friends with it.
                </div>
              </a>
              <a href="/Pages/Bravo">
                <div className="titreSousMenu">Bravo</div>
                <div className="descriptionSousMenu">
                  If what you're doing doesn't make you happy - you're doing the
                  wrong thing. Isn't that fantastic that you can create an
                  almighty tree that fast?
                </div>
              </a>
              <a href="/Pages/Charlie">
                <div className="titreSousMenu">Charlie</div>
                <div className="descriptionSousMenu">
                  Poor old tree. There he comes. Don't hurry. Take your time and
                  enjoy.
                </div>
              </a>
              <a href="/Pages/Delta">
                <div className="titreSousMenu">Delta</div>
                <div className="descriptionSousMenu">
                  No pressure. Just relax and watch it happen. Each highlight
                  must have it's own private shadow. And maybe, maybe, maybe...
                </div>
              </a>
              <a href="/Pages/Echo">
                <div className="titreSousMenu">Echo</div>
                <div className="descriptionSousMenu">
                  In your world you have total and absolute power. Only eight
                  colors that you need.
                </div>
              </a>
            </div>
          </div>
          <div className="colonneMenu">
            {/********************/}
            {/**** QUOI FAIRE ****/}
            {/********************/}
            <div id="faire" className="premierNiveau" onMouseEnter={toggleMenu}>
              Quoi faire? <FaAngleDown className="flecheBas" />
            </div>
            <div
              className={`${
                isMenuOpen === "faire" ? "sousMenu show" : "sousMenu hide"
              }`}
            >
              <a href="/Pages/Activite">
                <div className="titreSousMenu">Les activités</div>
                <div className="descriptionSousMenu">
                  Use absolutely no pressure. Just like an angel's wing. Let
                  your imagination be your guide.
                </div>
              </a>
              <a href="/Pages/Hebergement">
                <div className="titreSousMenu">L'hébergement</div>
                <div className="descriptionSousMenu">
                  Learn when to stop. Have fun with it. Exercising the
                  imagination, experimenting with talents, being creative; these
                  things, to me, are truly the windows to your soul.
                </div>
              </a>
              <a href="/Pages/Evenement">
                <div className="titreSousMenu">Les évènements</div>
                <div className="descriptionSousMenu">
                  It's almost like something out of a fairytale book. It's life.
                  It's interesting. It's fun. Let's have a happy little tree in
                  here
                </div>
              </a>
            </div>
          </div>
          <div className="colonneMenu">
            {/********************/}
            {/**** ENTREPRISE ****/}
            {/********************/}
            <div
              id="entreprise"
              className="premierNiveau"
              onMouseEnter={toggleMenu}
            >
              Notre entreprise <FaAngleDown className="flecheBas" />
            </div>
            <div
              className={`${
                isMenuOpen === "entreprise" ? "sousMenu show" : "sousMenu hide"
              }`}
            >
              <a href="/Pages/Logoipsum">
                <div className="titreSousMenu">Logoipsum</div>
                <div className="descriptionSousMenu">
                  Nothing's gonna make your husband or wife madder than coming
                  home and having a snow-covered dinner.
                </div>
              </a>
              <a href="/Pages/Historique">
                <div className="titreSousMenu">Historique</div>
                <div className="descriptionSousMenu">
                  I started painting as a hobby when I was little. I didn't know
                  I had any talent.
                </div>
              </a>
              <a href="/Pages/Equipe">
                <div className="titreSousMenu">L'équipe</div>
                <div className="descriptionSousMenu">
                  Put light against light - you have nothing. Put dark against
                  dark - you have nothing. It's the contrast of light and dark
                  that each give the other one meaning.
                </div>
              </a>
              <a href="/Pages/Emplois">
                <div className="titreSousMenu">Emplois</div>
                <div className="descriptionSousMenu">
                  Of course he's a happy little stone, cause we don't have any
                  other kind.
                </div>
              </a>
            </div>
          </div>
          <div className="colonneMenu">
            {/******************/}
            {/**** JOINDRE ****/}
            {/*****************/}
            <div className="premierNiveau">
              <a href="/Pages/NousJoindre">Nous joindre</a>
            </div>
          </div>
        </div>
        <div className="menuMobil">
          <div className="colonneMenu">
            {/******************/}
            {/***** MOBIL *****/}
            {/*****************/}
            <div id="mobil" className="premierNiveau" onMouseEnter={toggleMenu}>
              <FaBars id="mobil" className="icon" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Navbar;
